import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';

import { LineItemType } from '../../../../enums/lineItemType';
import Lineitem from '../../../../models/lineitem';
import { RootState } from "../../../../store";
import { config } from '../../../../utils/config';
import { redirectToURL } from '../../../../utils/url';
import Button from '../../elements/button';
import Icon from '../../elements/icon';
import Tooltip from '../../elements/tooltip';
import { ReactComponent as CartIcon } from '../../../../assets/icons/cart-icon-desktop.svg';
import './index.scss'
import { currencyFormatter } from '../../../../utils/currency';
import { onProceedToCheckoutOperation } from '../../../shopping-bag/ga-module';
import { useGetCartByCartIdQuery } from '../../../../store/newCart';
import i18n from '../../../../utils/translations/i18n';

declare const window: any;

export const MiniCart = (props) => {
    const [accessoriesToggles, setAccessoriesToggles] = useState({});
    const { applicationState: { user, currentPage,coupon,isShippingDisc} } = useSelector((state: RootState) => state);    
    const { t } = i18n;
    const {data,isFetching} = useGetCartByCartIdQuery({cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn}, {skip : (!user.userId || !user.cartId)});
    const locale = config('locale');
    const isDutchLocale = locale === 'nl-NL' || locale === 'nl-BE' || false;
    const miniCartLinkElement = document.getElementById('mini-cart-link');
    const getMultiDisplayStr = (multiDisplayArr): string => multiDisplayArr?.filter(e => e).map(e => e.split('|'[0]).join('-')).join(', ') ?? '';
    const toggleMiniCart = (event) => {
        event.preventDefault();
        props.setMiniCartOpenState(!props.IsMiniCartOpen);
    };
    const handleAccessoriesToggles = (event) => {
        const targetId = event.target.tagName === 'path' ? event.target.parentElement.id : event.target.id;
        setAccessoriesToggles({ ...accessoriesToggles, [targetId]: !(accessoriesToggles[targetId] ?? false) });
        event.stopPropagation();
    }
    const handleViewCartButtonClick = () => redirectToURL(`/${config('locale_details').current_sitename}/${t('shopping_cart_details.shoppingPageUrl')}`);
    const toCapitalized = config('withCapitalized') && config('locale') ? config('withCapitalized').includes(config('locale')):false;
    const handleViewCheckoutButtonClick = () => {
        redirectToURL(`/${config('locale_details').current_sitename}/${t('checkout_shipping.url')}`);
        onProceedToCheckoutOperation(data, currentPage,coupon,isShippingDisc)
    }

    const miniCartLink = (
        // eslint-disable-next-line
        <a href="" className={props.IsMiniCartOpen ? 'active' : ''} onClick={toggleMiniCart} aria-label={t('accessibility.mini_cart_button', 'View mini cart')}>
            <span className="cart-icon-count">{isFetching ? '' : data?.mainItemCount ?? 0}</span>
            <span className="cart-icon"><CartIcon fill={props.IsMiniCartOpen ? '#3A454E' : '#080A54'} /></span>
        </a>
    );

    const isMacSafariAndIphonebelowVer14 = window.np?.isMacSafariAndIphoneVerBelow14();

    const miniCartItems = (
        <div className="cart-items">
            {data?.lineItems && Object.keys(data?.lineItems).map((mainLineItemId) => {
                const mainLineItem: Lineitem = data?.lineItems[mainLineItemId][0].data;
                const accessories = data?.lineItems[mainLineItemId].filter(lineitem => lineitem?.type === LineItemType.ACCESSORY);
                const additionalCharges = data?.lineItems[mainLineItemId].filter(lineitem => lineitem?.type === LineItemType.ADDITIONALCHARGE);
                let appliedAdditionalCharges: any = [];
                additionalCharges.forEach((charge) => {
                    if (charge.appliedInCart) {
                        appliedAdditionalCharges.push(charge.data);
                    }
                });
                const compressedProductImageUrl = window.np?.compressImageURL(mainLineItem.productImageUrl,90,90,isMacSafariAndIphonebelowVer14); 
                return (<div id={`minicart-item-${mainLineItemId}`} className="row" key={mainLineItemId}>
                    <div className="col-sm-12 minicart-desktop__item">
                        <img alt={mainLineItem.name} height="90" src={compressedProductImageUrl} width="90" loading="lazy"></img>
                        <div className="minicart-desktop__item-description">
                            <h3 className="kilo minicart-item-name">{mainLineItem.name}</h3>
                            <ul className="base below-8 centi minicart-item-props">
                                <li>
                                    <span className="bold">{t('product_details.unit_price')}:</span>
                                    <span className='total-price'>{currencyFormatter(mainLineItem.actualUnitPrice, data?.fractionDigits)}</span>
                                </li>
                                <li>
                                    <span className="bold">{t('header.quantity')}: </span>
                                    <span className=''>{mainLineItem.totalQuantityWithSubItem > 0 ? mainLineItem.totalQuantityWithSubItem : mainLineItem.quantity}</span>
                                </li>
                                {mainLineItem.productAttributes?.userSelectionInfo?.map((userSelectionInfo) =>
                                    <li key={userSelectionInfo.attribute}>
                                        <span className="bold">{userSelectionInfo.attribute}: </span>
                                        {userSelectionInfo?.renderType === config('MULTI_SELECT_USER_INPUT') ?
                                            <span className=''>{getMultiDisplayStr(userSelectionInfo.multiDisplayValue)}</span>
                                            : <span>{userSelectionInfo.value}</span>}
                                    </li>
                                )}
                                {mainLineItem.productAttributes?.customizationInfo?.map((customizationInfo) =>
                                    customizationInfo.attribute === 'shopping_logic.imprint_color' &&
                                    <li key={customizationInfo.attribute}>
                                        <span className="bold">{t(customizationInfo.attribute)}: </span>
                                        <span dangerouslySetInnerHTML={{ __html: customizationInfo.value }} />
                                    </li>
                                )}
                                {accessories.length > 0 &&
                                    <li>
                                        <div className="">
                                            <div className="accessories_toggle">
                                                <div className="toggle__heading bold" onClick={handleAccessoriesToggles} id={`${mainLineItem.id}`} key={`accessories-${mainLineItem.id}`}>
                                                    <Icon icon={t('shopping_cart_details.tableHeaderAccessory', 'Accessories')} onClick={handleAccessoriesToggles} id={`${mainLineItem.id}`} className={`icon-plus ${accessoriesToggles[`${mainLineItem.id}`] === true ? 'is-open' : ''}`} />
                                                    {t('shopping_cart_details.tableHeaderAccessory')}
                                                </div>
                                                <div className={`toggle__content ${accessoriesToggles[`${mainLineItem.id}`] === true ? 'is-open' : ''}`}>
                                                    {accessories.map((accessory) =>
                                                        <ul key={accessory.id} className="mini-cart__accessory-details base">
                                                            <li>{accessory.data.name}</li>
                                                            <li><span className="bold">{t('product_details.unit_price')}: </span>{currencyFormatter(accessory.data.unitPrice, data?.fractionDigits)}</li>
                                                            <li><span className="bold">{t('header.quantity')}: </span>{accessory.data.quantity}</li>
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                }
                                {appliedAdditionalCharges.length > 0 && appliedAdditionalCharges.map((additionalCharge) =>
                                    <li>
                                        <span className="bold">{additionalCharge.name}
                                            {additionalCharge.description && <span className='tooltip-container additional-charge-tooltip'>
                                                <Tooltip
                                                    content={additionalCharge.description}
                                                    direction="top">
                                                </Tooltip>
                                            </span>} : </span>
                                        {t('header.logo_imprint_added')}
                                    </li>
                                )
                                }
                                {mainLineItem.setupChargeAdded &&
                                    <li>
                                        <span className="bold">
                                            {config("setupChargeHeading") ?? t('shopping_cart_details.setup')}
                                            <span className='tooltip-container'>
                                                <Tooltip
                                                    content={config("setupChargeTooltip") ?? t('shopping_cart_details.setup_title')}
                                                    direction="top">
                                                </Tooltip>
                                            </span> :
                                        </span> {t('header.logo_imprint_added')}
                                    </li>
                                }
                                {mainLineItem.logoImprintAdded &&
                                    <li>
                                        <span className="bold">{t('header.logo_imprint')} : </span>
                                        {t('header.logo_imprint_added')}
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>)
            })}
        </div>
    );

    const miniCartSummary = (
        <ul className="base minicart-desktop__summary">
            <li><span className='mini-cart-tax-ship-checkout'>{t('header.show_total_in_cart')}</span></li>
        </ul>
    );

    const miniCartButtons = (
        <div className="row">
            <div className="col-sm-6 mini-cart-view-btn">
                <Button className='btn btn--small btn--full-width btn--small-top mini-cart-btn btn--pill' dataLabel='cart-view'  style={{ textTransform: toCapitalized ? 'capitalize' : 'none' }} onClick={handleViewCartButtonClick}>
                    {t('header.view_cart')}
                </Button>
            </div>
            <div className="col-sm-6 mini-cart-checkout-btn">
                <Button className={`btn btn--small btn--full-width btn--small-top mini-cart-btn btn--pill ${isDutchLocale ? 'remove-captitalize' : ''}`} dataLabel='cart-checkout' onClick={handleViewCheckoutButtonClick}>
                    {t('header.checkout_button')}
                </Button>
            </div>
        </div>
    );


    const miniCartPortal = (
        <>
            <div className='mini-cart'>
                {miniCartLink}
                <div className={`sub-menu ${props.IsMiniCartOpen ? 'is-open' : ''}`} data-item-count={data?.mainItemCount}>
                    {data && data.mainItemCount > 0 ?
                        <>
                            {miniCartItems}
                            {miniCartSummary}
                            {miniCartButtons}
                        </> :
                        <div className="row">
                            <div className="col-sm-12">
                                <strong> {t('header.empty_cart')}</strong>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    );

    return miniCartLinkElement ? createPortal(miniCartPortal, miniCartLinkElement || document.body) : <></>;
};

